import { render, staticRenderFns } from "./EstimateClipboardEstimates.vue?vue&type=template&id=10f4b17d&"
import script from "./EstimateClipboardEstimates.vue?vue&type=script&lang=js&"
export * from "./EstimateClipboardEstimates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports